import { Component, OnInit, Input } from '@angular/core';
import { Shared } from '../shared.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  @Input() products;

  constructor(public shared: Shared) {
  }

  ngOnInit() {
      this.shared.product_query.next('everything');
  }

}



// WEBPACK FOOTER //
// ./src/app/menu/menu.component.ts